import { createContext, type ReactNode, useContext, useMemo } from 'react';

import MiniAppSDK from '@gopay/miniapp-client';

const SDKConfigContext = createContext<MiniAppSDK | null>(null);

export const SDKConfigProvider = ({ children }: { children: ReactNode }) => {
  const sdkInstance = useMemo(
    () => new MiniAppSDK({ useDummyService: true }),
    []
  );

  return (
    <SDKConfigContext.Provider value={sdkInstance}>
      {children}
    </SDKConfigContext.Provider>
  );
};

export const useMiniAppSDK = () => {
  const context = useContext(SDKConfigContext);
  if (!context) {
    throw new Error('useMiniAppSDK must be used within an SDKConfigProvider');
  }
  return context;
};
